import React from 'react'
import DetailCard from '../Main/DetailCard'

const value = {
  id: 1,
  heading: "Dock Leveler",
  intro:[
    "An electro-hydraulic dock leveler is described as a bridge for connecting a vehicle to a building.",
    "The series is completely driven by hydraulics with convenient operation and reliable running.",
    "Simple operation with the push of a button, Electric hydraulic Dock leveler is ideal for high usage dock areas. Operator pushes and hold the “raise’ button which activates the hydraulic pump and raises the deck. When the deck reaches the raised position the lip automatically extends. The operator releases the “raise” button and deck descends to rest on the trailer."
  ],
  features: [
    "Easy to bridge the gap between your factory floor and Vehicle floor.",
    "Low power consumption.",
    "Both side toe guards.",
    "Perfect solution for warehouses, Industries, factories.",
    "Rubber Bumpers at both side of Dock Leveler.",
    "Flap is also operated from hydraulic cylinder so it is easy and fast to use."
  ],
  structure:[
    "MS I-Beams are used under the top chequered plate to take all the load capacity.",
    "For Top platform 5/6/8mm chequered plate is used as per capacity.",
    "Bottom frame is made of MS Angles, Flat Bars and Channels.",
    "Flap will be made of 12/14/16mm MS Plate as per capacity requirements."
  ],
  imageUrl: "/images/dock-leveler.jpg",
};

const DockLeveler = () => {
  return (
  <>
  <DetailCard lists={value} />
  </>
  )
}

export default DockLeveler